export default function paymentDataLoad (url, successCallback, failureCallback, beforeSendCallback = $.noop, selectedRowValue = null, fetchInServer = false) {
  if (typeof window.paymentData !== 'undefined' && !fetchInServer) {
    if (selectedRowValue) {
      successCallback(windowPaymentDataGet(), null, null, selectedRowValue);
    } else {
      successCallback(windowPaymentDataGet())
    }
    return
  }

  $.ajax({
      url: url,
      timeout: (1000 * 60),
      beforeSend: function(jqXHR) {
        beforeSendCallback && beforeSendCallback(jqXHR)
      }
    })
    .done(function (data, textStatus, jqXHR) {
      const unitsDropdown = Object.keys(data).includes('units');
      const payments = unitsDropdown ? data.payments : data;
      const units = unitsDropdown ? data.units : null;

      windowPaymentDataSet(payments);
      windowUnitsPaymentDataSet(units);

      if (selectedRowValue) {
        successCallback(payments, textStatus, jqXHR, selectedRowValue);
      } else {
        successCallback(payments, textStatus, jqXHR);
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      failureCallback(jqXHR, textStatus, errorThrown)
    })
    .always(function (data, textStatus, _jqXHR) {
      if (textStatus === 'success') {
        const unitsDropdown = Object.keys(data).includes('units');
        const payments = unitsDropdown ? data.payments : data;
        const units = unitsDropdown ? data.units : null;

        windowPaymentDataSet(payments);
        windowUnitsPaymentDataSet(units);
      }
    })
}

function windowPaymentDataGet () {
  return window.paymentData
}

function windowPaymentDataSet (data) {
  window.paymentData = data;
}

function windowUnitsPaymentDataSet (data) {
  window.unitsPaymentData = data;
}

export function isMultipleLedgers(payment) {
  return payment.accounts !== undefined && payment.accounts.filter(account => account.balance !== 0).length > 1;
}
